import * as Cases from '../slices/casesSlice';

const HistoryStatus = (item: Cases.caseHistoryItemState) => {
    return (
        <div style={{ fontFamily: 'kanitbold', fontSize: 18, color: 'white', textAlign: 'center', marginLeft: 8, width: '120px' }}>
            {item.actions === 'RCS' && item.actioned === 'RCS' &&
                <div style={{ backgroundColor: '#98c000', padding: 8 }}>SIGNED</div>
            }
            {item.actions === 'R' && item.actioned === 'R' &&
                <div style={{ backgroundColor: '#98c000', padding: 8 }}>READ</div>
            }
            {item.actions === 'RCS' && item.actioned !== 'RCS' &&
                <div style={{ backgroundColor: '#dc0000', padding: 8 }}>NOT SIGNED</div>
            }
            {item.actions === 'R' && item.actioned !== 'R' &&
                <div style={{ backgroundColor: '#dc0000', padding: 8 }}>NOT READ</div>
            }
        </div>
    );
}

export default HistoryStatus;